import { OdometerHourmeterReportMessages, TranslationOdometerHourmeterReportMessages } from "../interfaces/odometerHourmeterReportMessages";

const odometerHourmeterReportMessages: TranslationOdometerHourmeterReportMessages = {
  [OdometerHourmeterReportMessages.title]: "Relatório Odômetro/Horímetro Total",
  [OdometerHourmeterReportMessages.startDateTime]: "Período Inicial",
  [OdometerHourmeterReportMessages.endDateTime]: "Período Final",
  [OdometerHourmeterReportMessages.date]: "Data",
  [OdometerHourmeterReportMessages.vehicleCode]: "Veículo",
  [OdometerHourmeterReportMessages.vehicleDescription]: "Descrição",
  [OdometerHourmeterReportMessages.originalAllocation]: "Alocação Original",
  [OdometerHourmeterReportMessages.currentAllocation]: "Alocação Atual",
  [OdometerHourmeterReportMessages.totalOdometer]: "Odômetro Total (KM)",
  [OdometerHourmeterReportMessages.totalHourmeter]: "Horímetro Total (Horas)",
  [OdometerHourmeterReportMessages.dailyOdometer]: "Odômetro Diário (KM)",
  [OdometerHourmeterReportMessages.dailyHourmeter]: "Horímetro Diário (Horas)",
  [OdometerHourmeterReportMessages.noDataFound]: "Nenhum dado encontrado para os filtros informados",
  [OdometerHourmeterReportMessages.invalidFilter]: "Filtro inválido. Informe pelo menos um critério de identificação",
  [OdometerHourmeterReportMessages.success]: "Relatório gerado com sucesso",
  [OdometerHourmeterReportMessages.error]: "Erro ao gerar relatório de odômetro/horímetro",
  [OdometerHourmeterReportMessages.invalidDateRange]: "Intervalo de datas inválido. Máximo permitido: 30 dias",
  [OdometerHourmeterReportMessages.fleet]: "Frota",
  [OdometerHourmeterReportMessages.selectVehicle]: "Selecione o veículo",
  [OdometerHourmeterReportMessages.allVehicles]: "Todos os veículos"
};

export const messages = odometerHourmeterReportMessages;
